import { render, staticRenderFns } from "./PlanCalculator.vue?vue&type=template&id=89cc9380"
import script from "./PlanCalculator.vue?vue&type=script&lang=js"
export * from "./PlanCalculator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports